module.exports = __webpack_public_path__ + "img/intro_pc_img04.c80728da.png";